import * as React from 'react';
import * as moment from 'moment';

import GridDayContent, { GridDayProps } from '../views/grid-day';
import GridDayEmpty, { GridDayEmptyProps } from '../views/grid-day-empty';

interface GridCellExternalProps {
    currentMonth: moment.Moment;
}

type GridCellProps = GridDayProps & GridDayEmptyProps & GridCellExternalProps;

const GridCell: React.StatelessComponent<GridCellProps> = (props) => {
    /**
     * Validation logic to check if the date is not contained within the range of [today, last day of month].
     */
    function isValidDate(): boolean {
        const isSameMonth = moment(props.day.date).startOf("month").isSame(props.currentMonth.clone().startOf("month"));
        const isAfterToday = moment(props.day.date).startOf("day").isSameOrAfter(moment().startOf("day"));

        return isSameMonth && isAfterToday
    }

    return (
        <div className={`grid-cell ${(isValidDate() ? 'has-events' : 'no-events')}`}>
            {
                isValidDate() ? <GridDayContent day={props.day} /> : <GridDayEmpty />
            }
        </div>
    );
}

export default GridCell;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/components/grid-cell.tsx